
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from "@/hooks/useReduxHooks";

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const authState = useAppSelector(state => state.auth);

  // const { isAuthenticated } = useAppSelector((state) => state.auth);
  const bearerToken = authState.token || sessionStorage.getItem("bearer_token")
  const location = useLocation();

  if (!bearerToken) {
    // Redirect to login page if not authenticated
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
